import { render, staticRenderFns } from "./SlideView.vue?vue&type=template&id=4e589f12&scoped=true&"
import script from "./SlideView.vue?vue&type=script&lang=js&"
export * from "./SlideView.vue?vue&type=script&lang=js&"
import style0 from "./SlideView.vue?vue&type=style&index=0&id=4e589f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e589f12",
  null
  
)

component.options.__file = "SlideView.vue"
export default component.exports